import { User } from "firebase";
import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router";
import AuthService from "../services/auth/auth.service";

export const AuthContext = React.createContext<{
    user: User | null,
    logout: () => void
}>({
    user: null,
    logout: null
});


const AuthContextProvider = ({
    children
}) => {

    const [user, setUser] = useState<User | null | undefined>(undefined);
    const history = useHistory();
    const location = useLocation();


    useEffect(() => {
        return AuthService.authStatus(setUser)
    }, [])

    useEffect(() => {
        // Wait until Firebase reports the first auth state to avoid login/dashboard flicker.
        if (user === undefined) {
            return;
        }

        if (!user && location.pathname !== "/login") {
            history.replace("/login")
            return;
        }

        if (user && location.pathname === "/login") {
            history.replace("/dashboard?view=bars")
        }
    }, [history, location.pathname, user])

    const contextValue = useMemo(() => ({
        user: user || null,
        logout: AuthService.logout
    }), [user]);

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    )
}


export default AuthContextProvider
